import { useDispatch, useSelector } from 'react-redux';
import { DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from 'reactstrap';
import { Link, withRouter } from "react-router-dom";
import { logoutUser } from "../../redux/actions/";
import { IMAGE_URL } from "../../config/Config";

const UserProfile = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);


    const AuthButton = withRouter(({ history }) =>
        <a className="dropdown-item" href="/" onClick={() => dispatch(logoutUser(), setTimeout(() => history.push("/"), 0))}>
            <i className="fas fa-sign-out-alt"></i>  خروج
        </a>);

    return (
        <UncontrolledDropdown className="user-profile">
            <DropdownToggle color="link" className="user-header h-100">
                <img src={`${IMAGE_URL}${user.photo}`} alt={`${user.first_name} ${user.last_name}`} />
            </DropdownToggle>
            <DropdownMenu className="user-dropdown">
                <DropdownItem header>
                    <img src={IMAGE_URL + user.photo} className="img-fluid rounded-circle z-depth-0" alt={user.first_name + " " + user.last_name} /> {user.first_name + " " + user.last_name}
                </DropdownItem>


                <Link to="/users" className="dropdown-item" ><i className="far fa-user-circle"></i> حساب کاربری </Link>
                <Link to="/my-complains" className="dropdown-item" ><i className="fas fa-chart-line"></i> نظرات و شکایات </Link>
                <Link to="/my-comments" className="dropdown-item" ><i className="far fa-comment"></i> دیدگاه‌ها </Link>
                <Link to="/massages" className="dropdown-item" ><i className="far fa-bell"></i> پیام‌ها </Link>
                <DropdownItem divider />
                <AuthButton />
            </DropdownMenu>
        </UncontrolledDropdown>
    );
};

export default withRouter(UserProfile);
